/*
SEND-INVITATION-BUTTON
Send invitation to another user to connect into the app
*/
import { User } from "@/redux/user.types"
import ListButton from "./list-button"
import { t } from "i18next"
import { faEnvelope, faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"

interface Props {
  user: User
  onClick: Function
}

export default function SendInvitationButton(props: Props) {
  //Get color for email dot
  function getSendDotColor() {
    if (props.user.connectedAt) {
      return "green"
    } else if (props.user.invitedAt) {
      return "orange"
    } else {
      return "red"
    }
  }

  //Display text for tooltip
  function getSendText() {
    let text = hasEmail() ? t("utils_email_send_action") : t("invitation_no_email") + " !"

    if (props.user.connectedAt) {
      text =
        text +
        " (" +
        t("user_connected_at", {
          date: new Date(props.user.connectedAt).toLocaleDateString(navigator.language, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
        }) +
        ")"
    } else if (props.user.invitedAt) {
      text =
        text +
        " (" +
        t("user_invited_at", {
          date: new Date(props.user.invitedAt).toLocaleDateString(navigator.language, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
        }) +
        ")"
    }

    return text
  }

  //Check if email was provided for user
  function hasEmail(): boolean {
    return props.user.email && props.user.email.length > 0 ? true : false
  }

  return (
    <ListButton
      icon={props.user.connectedAt ? faEnvelopeOpen : faEnvelope}
      dot={hasEmail()}
      dotColor={getSendDotColor()}
      isInactive={props.user.invitedAt || props.user.connectedAt || !hasEmail() ? true : false}
      onClick={() => (hasEmail() ? props.onClick() : toast(t("invitation_no_email"), { type: "error" }))}
      text={getSendText()}
    />
  )
}
